<div class="bgCard" >
    <div class="dilogStl">
        <h1 style="
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 33px;" mat-dialog-title>Synergy Sessions Count Report</h1>
           <button align="end" mat-icon-button mat-dialog-close >
            <mat-icon style="color:#0038FF" svgIcon="feather:x"></mat-icon>       
          </button>
    </div>
    <mat-dialog-content class="mat-typography" >
        <div class="card dataCard">
            <div class="col-12 row">
                <div class="col-sm-12 col-md-12 col-lg-6">
                    <div class="fw-bold fieldName">
                        Synergy Session Date
                        <span class="text-danger">*</span>
                    </div>
                    <div class="">
                        <mat-form-field class="flex-auto gt-xs:pr-3 w-full">
                            <input matInput readonly [matDatepicker]="picker" [placeholder]="'Synergy Session Date'" [(ngModel)]="payrollDate">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class=" mt-8 mb-4 d-flex justify-content-center">
                <div class="">
                    <button class="ml-4 addBtn" [ngClass]="{'btn-clr': payrollDate}" mat-flat-button [color]="'primary'" [disabled]="!payrollDate" (click)="getSynergyReport()" >
                        <mat-icon class="white-icon" [svgIcon]="'mat_outline:file_download'"></mat-icon>
                    <span class="ml-2 mr-1 txt" style="color: black">Download</span>
                    </button>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>
